import React, { useEffect, useState } from 'react';
import HomeownerPlanStep from './HomeownerPlanStep';
import SetupScreen from './SetupScreen';
import { useTheme } from '../ThemeContext';
import { homeownerPost, homeownerTasks, updateHomeownerClient } from '../utils/homeownerApi';

/**
 * Shown once, after the invite password. Skip leaves the year of tasks as scheduled.
 */
export default function HomeownerPlanWelcome({ client, onDone, onLogout }) {
  const { colors, isDark } = useTheme();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [tasksReady, setTasksReady] = useState(false);

  useEffect(() => {
    let cancel = false;
    if (typeof homeownerTasks !== 'function') return undefined;
    const pending = homeownerTasks('');
    if (!pending || typeof pending.then !== 'function') return undefined;
    pending
      .then((data) => {
        const rows = data && (data.data || data.tasks);
        if (!cancel) setTasksReady(Array.isArray(rows) && rows.length > 0);
      })
      .catch(() => {
        if (!cancel) setTasksReady(false);
      });
    return () => {
      cancel = true;
    };
  }, []);

  const finish = async (fields, apply) => {
    setSaving(true);
    setError('');
    try {
      await updateHomeownerClient(fields);
      if (apply) {
        await homeownerPost('/.netlify/functions/homeowner-plan', { action: 'apply-answers' });
      }
      if (onDone) await onDone();
    } catch (saveError) {
      console.error('Plan welcome save failed', saveError);
      setError('Could not save those answers. You can skip this and try again later.');
      return false;
    } finally {
      setSaving(false);
    }
    return true;
  };

  return (
    <SetupScreen>
      <div style={{ maxWidth: '560px', margin: '0 auto' }}>
        <h1 style={{ margin: '0 0 1.25rem', fontSize: '1.6rem', color: colors.text }}>
          Your year of home care
        </h1>
        <HomeownerPlanStep
          welcome
          tasksReady={tasksReady}
          initial={client}
          saving={saving}
          onSave={(fields) => finish(fields, true)}
          onSkip={() => finish({ onboarding_completed_at: new Date().toISOString() }, false)}
        />
        {error ? <p style={{ color: isDark ? '#fecaca' : '#991b1b' }}>{error}</p> : null}
        {onLogout ? (
          <button
            type="button"
            onClick={onLogout}
            style={{
              marginTop: '0.5rem',
              minHeight: '44px',
              background: 'transparent',
              border: 'none',
              color: colors.textSecondary,
              fontSize: '1rem',
              cursor: 'pointer',
            }}
          >
            Log out
          </button>
        ) : null}
      </div>
    </SetupScreen>
  );
}
